import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route, NavLink, useLocation, Link, BrowserRouter } from 'react-router-dom';
import logo from '../assets/logo.PNG'

const Navbar = () => {


  let location = useLocation();
  useEffect(() => {
    if(location.pathname==='/SignUp'){
      setShowlog(true)
      setShowsignup(false)
    }
    else if(location.pathname==='/Login'){
      setShowlog(false)
      setShowsignup(true)
    }
    else{
      setShowlog(true)
      setShowsignup(false)
    }
  }, [location]);

const [show , setShow] = useState( false)  
const [showlog , setShowlog] = useState( true)
const [showsignup , setShowsignup] = useState( false)

const [showdrop, setShowdrop] = useState( false)

  return (
    <>
      <div className=' py-4 w-[95%] mx-auto' id='movetotop'>
        <nav className="bg-[#E5E5E5;] border-gray-200 px-2 h-11 sm:px-4 py-2.5  ">
          <div className="container flex flex-wrap h-11 justify-between items-center mx-auto">
            <a href="#" className="flex">
              <Link to="/" > <img src={logo} alt='' className='h-10 w-26  ' /></Link>
            </a>
            <div className="flex md:order-2">
             
            <div class=" ">
      <div class="group inline-block relative">
      {showlog ?  <button onClick={() => { setShowdrop(!showdrop) }} className={`   ${location.pathname === "/" ? " bg-[#409BF5] ; text-[#FBFEFF]  " : "text-[#409BF5]"} border border-[#409BF5]    font-bold rounded-2xl text-sm md:px-5 px-4 py-2.5 text-center mr-3 md:mr-0' inline-flex items-center`}
        >
         
        
          {location.pathname === "/" ? "Login" : "Login"}   <svg
            class="fill-current h-4 w-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
          >
            <path
              d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
            />
          </svg></button> :null}
          {showdrop ?   <ul class="absolute  -ml-[28px] w-[160px] text-gray-700 pt-1  ">
          <li  onClick={() => { setShowdrop(false)   }} class="">
            <Link to='/Login' class="rounded-t bg-gray-50 hover:bg-gray-200 text-[14px] font-semibold py-2 px-4 block whitespace-no-wrap"  >Login</Link>
          </li>
          <li  onClick={() => { setShowdrop(false)   }} class="">
          <Link to='/MyAccount' class="rounded-t bg-gray-50 hover:bg-gray-200 text-[14px] font-semibold py-2 px-4 block whitespace-no-wrap" >User Profile</Link>
          </li>
          <li  onClick={() => { setShowdrop(false)   }} class="">
          <Link to='/BizProfile' class="rounded-t bg-gray-50 hover:bg-gray-200 text-[14px] font-semibold py-2 px-4 block whitespace-no-wrap"  >Business Profile</Link>
          </li>
        </ul> :null}
      </div>
    </div>
            
            {showsignup ?  <Link to="/SignUp" > <button onClick={() => { setShowsignup(false); setShowlog(true); }} className='border border-[#409BF5] text-[#409BF5] font-bold rounded-2xl text-sm md:px-7 px-4 py-2.5 text-center mr-3 md:mr-0'  > Sign Up </button></Link> :null}
      
              {/* <button className='bg-blue-500   text-white font-medium rounded-2xl text-sm px-5 py-2.5 text-center mr-3 md:mr-0'> <Link to="MyAccount" >  My Account</Link></button> */}

              <button   onClick={()=> {setShow(!show) ; }} data-collapse-toggle="mobile-menu-4"   type="button" className="inline-flex items-center p-2 text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600" aria-controls="mobile-menu-4" aria-expanded="false">
                <span className="sr-only">Open main menu</span>
                <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clip-rule="evenodd"></path></svg>
                <svg className="hidden w-6 h-6" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path></svg>
              </button>
            </div>
            {show? <div id="elementId" className="  md:hidden  bg-gray-50 reltive z-40 justify-end items-right w-full md:flex md:w-[50%] md:order-1"  >
              <ul className="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium">
                <li>
                  <Link to="/" onClick={() => { setShow(false); }} className={`block  ${location.pathname === "/" ? "active" : ""} py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100  md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 `}>Home</Link>
                </li>
                <li>
                  <Link to="/Search" onClick={() => { setShow(false); }} className={`block  ${location.pathname === "/Search" ? "active" : ""} py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100  md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 `}>List Your Court</Link>
                </li>
                <li>
                  <Link to="/BookCourt" onClick={() => { setShow(false); }} className={`block ${location.pathname === "/BookCourt" ? "active" : ""} py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100  md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0  `}>Book A Court</Link>
                </li>
                <li>
                  <Link to="/About" onClick={() => { setShow(false); }} className={`block  ${location.pathname === "/About" ? "active" : ""} py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100  md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 `}>About Padel Buddy</Link>
                </li>

              </ul>
            </div> :null}


            <div id="elementId" className="  hidden md:block justify-end items-right w-full md:flex md:w-[50%] md:order-1"  >
              <ul className="flex flex-col mt-4 md:flex-row md:space-x-8 md:mt-0 md:text-sm md:font-medium">
                <li>
                  <Link to="/" className={`block  ${location.pathname === "/" ? "active" : ""} py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 text-[12px] font-semibold md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 `}>Home</Link>
                </li>
                <li>
                  <Link to="/Search" className={`block  ${location.pathname === "/Search" ? "active" : ""} py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 text-[12px] font-semibold md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 `}>List Your Court</Link>
                </li>
                <li>
                  <Link to="/BookCourt" className={`block ${location.pathname === "/BookCourt" ? "active" : ""} py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 text-[12px] font-semibold md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0  `}>Book A Court</Link>
                </li>
                <li>
                  <Link to="/About" className={`block  ${location.pathname === "/About" ? "active" : ""} py-2 pr-4 pl-3 text-gray-700 border-b border-gray-100 text-[12px] font-semibold md:hover:bg-transparent md:border-0 md:hover:text-blue-700 md:p-0 `}>About Padel Buddy</Link>
                </li>


                

              </ul>
            </div>
          </div>
        </nav>


      </div>


    </>
  )
}
// }
// md:dark:hover:text-white dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white md:dark:hover:bg-transparent dark:border-gray-700
export default Navbar